import React from 'react'

import MainHeaderNew from './components/MainHeaderNew.js'
import {
  CaseStudyBlock,
  TestimonialBlock,
  Footer,
  GetInTouchBlock,
  SecondaryPageTopBlock
} from './components/helpers.js'
import useAnimationEffects from './components/useAnimationEffects.js'

function AdvisorsPage(props) {

  //animation for bg lines and lines in getintouch block
  useAnimationEffects('secondary_page');


	return (
		<div className="main-page-layout companies-page" id='scrollableElement'>
			<MainHeaderNew />
      <div className='main-content-new'>

        <SecondaryPageTopBlock index={1} />

        <CaseStudyBlock index={1}/>

        <TestimonialBlock index={2} />

        <GetInTouchBlock index={2}/>

        <Footer />

      </div>
		</div>
	)
}

export default AdvisorsPage;
